export default __webpack_public_path__ + "static/media/Shruti-Bidarkar-500x500.1ad1742b.jpg";